import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  ChangeDetectorRef,
  NgZone,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '@app/core/services/common.service';
import { SocketService } from '../carrier/services/socket.service';
import { LocalStorageService } from '@app/core/services/local-storage.service';
import { ChatMessageType, ChatRoomType, eUserType } from '@app/shared/enum/user-type';
import { SharedModalService } from '@app/shared/services/shared-modal.service';
import { PendingAttachment } from '@app/shared/models/chat-attachment.model';

@Component({
  selector: 'app-group-chat',
  templateUrl: './group-chat.component.html',
  styleUrls: ['./group-chat.component.scss'],
})
export class GroupChatComponent implements OnInit {

  @ViewChild('scrollMe') myScrollContainer!: ElementRef;
  @ViewChild('inputFile') myInputVariable!: ElementRef;

  joinRoomId: string = null;
  sender: any;


  memberSearchQuery = '';
  addMemberQuery = '';
  filteredMembers: any[] = [];
  userSearchResults: any[] = [];

  showGroupInfo = false;
  showSearchPanel = false;
  searchKeyword: string = '';
  isSearching = false;
  searchResults: any[] = [];
  searchPage = 1;
  searchPageSize = 20;
  hasMoreSearch = false;
  scrollLock: 'UP' | 'DOWN' | null = null;
  isSearchJump = false;
  hasSearched = false;
  hasMoreOlder = true;
  hasMoreNewer = true;
  newMessagesCount = 0;
  isLoading = false;
  hasNewMessages: any
  chatMembers: any
  isAddingMember: number | null = null;
  isRemovingMember: number | null = null; 
  searchDebounceTimer: any = null;
  isSearchingUsers = false;
  isChatAccess:Boolean = false;


  toggleGroupInfo() {
    if (this.showSearchPanel) {
      this.showSearchPanel = false;
    }
    this.showGroupInfo = !this.showGroupInfo;
  }

  toggleSearchPanel() {
    if (this.showGroupInfo) {
      this.showGroupInfo = false;
    }
    this.showSearchPanel = !this.showSearchPanel;
  }

  messages: any[] = [];
  groupedMessages: any[] = [];
  Members = 2
  limit = 20;
  cursorId: number | null = null;
  hasMore = true;
  socketReady = false;
  autoScroll = true;
  private messageIdSet = new Set<number>();
  private attachmentPreviewCache = new Map<string, string>();
  private attachmentPreviewLoading = new Set<string>();
  /** Keys whose preview fetch failed, mapped to the timestamp of the failure. */
  private attachmentPreviewFailed = new Map<string, number>();
  private readonly attachmentPreviewRetryMs = 30000;

  pendingAttachments: PendingAttachment[] = [];
  isDraggingAttachment = false;
  private dragCounter = 0;
  openChatBox = true

  profileUrl = this._localStorageService.getValueByKey('profileUrl');
  companyName = this._localStorageService.getValueByKey('companyName');
  loggedInUsername = this._localStorageService.getValueByKey('loggedInUsername');
  userType: any = this._localStorageService.getValueByKey('userType');
  profileData: any = this._localStorageService.getValueByKey('userId');
  userId = this.profileData ? JSON.parse(this.profileData) : null;
  seenPopoverMessage: any = null;
  currectUserId: number
  chatMemberName: any
  editingMessageId: number | null = null;
  editedText: string = '';
  _emptyMessageError = false;
  replyToMessage: {
    messageId: number;
    message: string;
    senderName: string;
  } | null = null;



  constructor(
    private socketService: SocketService,
    private http: HttpClient,
    private commonService: CommonService,
    private _localStorageService: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private _sharedModalService: SharedModalService,
    private ngZone: NgZone,
    public dialogRef: MatDialogRef<GroupChatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.sender = data.senderInfo;
  }

  // ================= INIT =================
  async ngOnInit(): Promise<void> {
    this.currectUserId = Number(this.userId);
    await this.socketService.connect(this.currectUserId);
    this.socketReady = true;
    this.messages = [];
    this.groupedMessages = [];
    this.messageIdSet.clear();
    this.cursorId = null;
    this.hasMore = true;
    this.autoScroll = true;
    this.socketService.onUserOnline(() => this.loadOnlineUsers(this.chatMembers));
    // this.socketService.onUserOffline(() => this.loadOnlineUsers());
    this.socketService.onNewMessage(async (msg: any) => {
      const normalized = this.normalizeMessage(msg);
      if (
        localStorage.getItem('loggedInUsername')?.toLowerCase() !==
        normalized.userName?.toLowerCase()
      ) {
        if (Notification.permission == 'granted') {
          navigator.serviceWorker.getRegistration().then(registration => {
            registration?.showNotification(normalized.userName, {
              body: normalized.message,
            });
          });
        }
      }
      this.socketService.onMessageSeen(payload => {
        const seenUsers = payload.data;
        if (!Array.isArray(seenUsers) || !seenUsers.length) return;
        const lastMessage = this.messages[this.messages.length - 1];
        if (!lastMessage) return;
        lastMessage.seenBy = lastMessage.seenBy || [];
        seenUsers.forEach(user => {
          if (!lastMessage.seenBy.some(u => u.id === user.id)) {
            lastMessage.seenBy.push(user);
          }
        });
      });
      if (this.openChatBox && normalized.userName != this.loggedInUsername) {
        this.markMessageAsRead(normalized);
      }
      this.ngZone.run(() => {
        if (this.messageIdSet.has(normalized.id)) return;
        const wasAtBottom = this.isUserAtBottom();
        this.messageIdSet.add(normalized.id);
        this.messages.push(normalized);
        this.groupByDate();

        if (wasAtBottom) {
          this.newMessagesCount = 0;
          this.hasNewMessages = false;
          setTimeout(() => this.scrollToBottom());
        } else {
          this.newMessagesCount++;
          this.hasNewMessages = true;
          this.cdr.detectChanges();
        }
      });
    });
    this.socketService.onMessageDeleted(({ messageId }) => {
      this.messages = this.messages.map(msg =>
        msg.id === messageId
          ? {
            ...msg,
            message: 'This message was deleted',
            metadata: { ...(msg.metadata || {}), isDeleted: true },
          }
          : msg
      );
      this.groupByDate();
    });

    this.socketService.onMessageEdited(updatedMsg => {
      const index = this.messages.findIndex(m => m.id === updatedMsg.id);
      if (index === -1) return;

      this.messages[index] = {
        ...this.messages[index],
        message: updatedMsg.message,
        metadata: {
          ...(this.messages[index].metadata || {}),
          ...(updatedMsg.metadata || {}),
          edited: true,
        },
      };

      this.groupByDate();
    });

    this.socketService.onMemberAdded((data: any) => {
      this.ngZone.run(() => {
        if (String(data.roomId) !== this.joinRoomId) return;

        const member = data.member;
        const alreadyExists = this.chatMemberName?.some((m: any) => m.id === member.id);
        if (alreadyExists) return;

        const newMember = {
          id: member.id,
          name: member.name,
          role: member.role,
          userType: member.userType,
          companyName: member.companyName ?? null,
          logo: member.logo ?? null,
          isDefault: member.isDefault ?? false,
          isLoadPoster: member.isLoadPoster ?? false,
          isCarrierAdmin: member.isCarrierAdmin ?? false,
          isOnline: false,
        };

        this.chatMemberName = [...(this.chatMemberName || []), newMember];
        this.filteredMembers = [...this.chatMemberName];
       const addedByName =
              data.addedByName ||
              data.systemMessage?.metadata?.addedByName ||
              member.systemMessage?.metadata?.addedByName ||
              this.loggedInUsername ||
              'Someone';

        const systemMessage = {
          id: Date.now(),
          senderId: 0,
          chatRoomId: Number(this.joinRoomId),
          message: `${addedByName} added ${member.name} to the chat.`,
          metadata: {
            system: true,
            action: 'member_added',
            addedByName,
            addedUserName: member.name,
          },
          userName: addedByName,
          messageType: ChatMessageType.TEXT,
          isSystem: true,
          messageDate: new Date(),
          seenBy: [],
        };

        this.messages.push(systemMessage);
        this.groupByDate();
        this.cdr.detectChanges();

        setTimeout(() => {
          this.scrollToBottom();
        });

        // Update isAlreadyInRoom in search results
        this.userSearchResults = this.userSearchResults.map(u =>
          u.id === member.id ? { ...u, isAlreadyInRoom: true } : u
        );       

        this.cdr.detectChanges();
         this.canUserHaveChatAccess()
      });
    });

    this.socketService.onMemberRemoved((data: any) => {
      this.ngZone.run(() => {
        if (String(data.roomId) !== this.joinRoomId) return;

        const removedMember = this.chatMemberName?.find(
          (m: any) => Number(m.id) === Number(data.removedUserId)
        );

        const removedByMember = this.chatMemberName?.find(
          (m: any) => Number(m.id) === Number(data.removedBy)
        );

        const removedByName =
          removedByMember?.name ||
          data.removedByName ||
          'Someone';

        // Remove member from local lists
        this.chatMembers =
          this.chatMembers?.filter(
            (m: any) => Number(m.id) !== Number(data.removedUserId)
          ) || [];

        this.chatMemberName =
          this.chatMemberName?.filter(
            (m: any) => Number(m.id) !== Number(data.removedUserId)
          ) || [];

        this.filteredMembers = [...this.chatMemberName];

        this.userSearchResults = this.userSearchResults.map(u =>
          Number(u.id) === Number(data.removedUserId)
            ? { ...u, isAlreadyInRoom: false }
            : u
        );

        // Show local system message immediately
        const systemMessage = this.normalizeMessage({
          id: Date.now(),
          senderId: 0,
          chatRoomId: Number(this.joinRoomId),
          sender: {
            name: removedByName,
          },
          message: '',
          metadata: {
            system: true,
            action: 'member_removed',
            removedBy: data.removedBy || this.currectUserId,
            removedByName,
            removedUserId: data.removedUserId,
            removedUserName: removedMember?.name || data.removedUserName || 'a member',
          },
          messageType: ChatMessageType.TEXT,
          messageDate: new Date(),
          seenBy: [],
        });

        this.messages.push(systemMessage);
        this.groupByDate();

        if (Number(data.removedUserId) === Number(this.currectUserId)) {
          this.commonService.showSnakeBar('You have been removed from this chat');
          this.canUserHaveChatAccess()
          return;
        }

        this.cdr.detectChanges();

        setTimeout(() => {
          this.scrollToBottom();
        });
      });
    });

    this.loadMessages();
    this.canUserHaveChatAccess()
  }
  scrollToNewMessages(): void {
    this.scrollToBottom();
    this.newMessagesCount = 0;
    this.hasNewMessages = false;
    this.autoScroll = true;
  }
  onSearchMessages(): void {
    if (!this.searchKeyword.trim() || !this.joinRoomId) return;
    if (this.isSearching) return;

    this.hasSearched = true;
    this.isSearching = true;
    this.searchResults = [];
    this.searchPage = 1;

    this.socketService.searchMessages({
      roomId: Number(this.joinRoomId),
      keyword: this.searchKeyword.trim(),
      pageNumber: this.searchPage,
      pageSize: this.searchPageSize,
    }).subscribe({
      next: res => {
        this.searchResults = res?.data?.messages || [];
      },
      error: () => {
        this.commonService.showSnakeBar('Search failed');
      },
      complete: () => {
        this.isSearching = false;
      }
    });
  }

  jumpToSearchMessage(chat: any): void {
    if (!chat?.id || !this.joinRoomId) return;
    this.isSearchJump = true;
    this.hasMoreOlder = true;
    this.hasMoreNewer = true;
    this.isLoading = true;
    this.socketService.getMessagesAround({
      roomId: Number(this.joinRoomId),
      messageId: chat.id,
      pageSize: 20,
    }).subscribe(res => {
      const msgs = res?.data?.messages || [];
      this.messages = [];
      this.groupedMessages = [];
      this.messageIdSet.clear();
      const normalized = msgs.map(m => this.normalizeMessage(m));
      normalized.forEach(m => this.messageIdSet.add(m.id));

      this.messages = normalized;
      this.groupByDate();
      this.cdr.detectChanges();
      setTimeout(() => {
        const el = document.getElementById(`message-${chat.id}`);
        if (el) {
          el.scrollIntoView({ block: 'center' });
          el.classList.add('highlight-message');
          setTimeout(() => el.classList.remove('highlight-message'), 2000);
          this.isLoading = false;
        }
      }, 100);

      requestAnimationFrame(() => {
        document
          .getElementById(`message-${chat.id}`)
          ?.scrollIntoView({ block: 'center' });
      });
    });
  }
  loadOlderFromSearch(): void {
    if (this.isLoading) return;
    this.isLoading = true;
    const el = this.myScrollContainer.nativeElement;
    const prevHeight = el.scrollHeight;
    const firstId = this.messages[0]?.id;
    this.socketService.getmessages({
      type: ChatRoomType.GROUP,
      loadId: this.data?.userInfo?.loadData?.loadId ?? this.data?.loadId,
      cursorId: firstId,
      pageSize: this.limit,
    }).subscribe(res => {
      const msgs = res?.data?.messages || [];

      if (!msgs.length) {
        this.hasMoreOlder = false;
        this.isLoading = false;
        return;
      }

      const normalized = msgs
        .map(m => this.normalizeMessage(m))
        .filter(m => !this.messageIdSet.has(m.id))
        .reverse();
      normalized.forEach(m => this.messageIdSet.add(m.id));
      this.messages = [...normalized, ...this.messages];
      this.groupByDate();
      this.cdr.detectChanges();
      el.scrollTop = el.scrollHeight - prevHeight;

      this.isLoading = false;
    });
  }


  loadNewerFromSearch(): void {
    if (!this.messages.length) return;
    this.isLoading = true;
    const lastId = this.messages[this.messages.length - 1].id;
    this.socketService.getmessages({
      type: ChatRoomType.GROUP,
      loadId:
        this.data?.userInfo?.loadData?.loadId ?? this.data?.loadId,
      cursorId: lastId,
      pageSize: this.limit,
      direction: 'NEWER',
    }).subscribe(res => {
      const msgs = res?.data?.messages || [];

      if (!msgs.length) {
        this.hasMoreNewer = false;
        this.isLoading = false;
        return;
      }

      const normalized = msgs
        .map(m => this.normalizeMessage(m))
        .filter(m => !this.messageIdSet.has(m.id));

      normalized.forEach(m => this.messageIdSet.add(m.id));

      this.messages = [...this.messages, ...normalized];
      this.groupByDate();
      this.cdr.detectChanges();

      requestAnimationFrame(() => {
        const el = this.myScrollContainer.nativeElement;
        el.scrollTop = el.scrollTop - 1;
        this.scrollLock = null;
      });

      this.isLoading = false;
      this.isLoading = false;
    });
  }

  clearSearch(): void {
    this.searchKeyword = '';
    this.searchResults = [];
    this.isSearching = false;
  }


  onSendOrEdit(input: HTMLInputElement) {
    const text = input.value.trim();
    const hasAttachments = this.pendingAttachments.some(a => a.status === 'done');
    if (!text && !hasAttachments) { this._emptyMessageError = true; return; }
    this._emptyMessageError = false;
    if (this.editingMessageId) {
      const message = this.messages.find(
        m => m.id === this.editingMessageId
      );
      if (!message) return;

      this.saveEdit(message);
      input.value = '';
    }
    else {
      this.sendMessage(text);
      input.value = '';
    }
  }
  loadOnlineUsers(chatMembers: any[]) {
    this.socketService.getOnlineUsers().subscribe({
      next: (res) => {
        const onlineUsers: number[] = res?.data?.onlineUsers || [];
        const onlineUserSet = new Set<number>(onlineUsers);
        const finalUsers = chatMembers.map(user => ({
          id: user.id,
          name: user.name,
          role: Number(user.id) === Number(this.currectUserId) ? "You" : user.role,
          companyName: user.companyName ?? null,
          userType: user.userType ?? null,
          logo: user.logo ?? null,
          isDefault: user.isDefault ?? false,
          isLoadPoster: user.isLoadPoster ?? false,
          isCarrierAdmin: user.isCarrierAdmin ?? false,
          ...(user.branchName || user.emailId || user.phoneNo
            ? {
              branchName: user.branchName ?? null,
              branchLocation: user.branchLocation ?? null,
              emailId: user.emailId ?? null,
              phoneNo: user.phoneNo ?? null,
              roleType: user.roleType ?? null,
            }
            : {}),
          isOnline: onlineUserSet.has(user.id),
}));
        this.chatMemberName = finalUsers;
        this.filteredMembers = [...finalUsers]; // add this line
      },
      error: (err) => {
        this.commonService.showSnakeBar('Failed to load online users');
      },
    });
  }

  markMessageAsRead(message: any): void {
    if (!message.chatRoomId) {
      return;
    }

    this.socketService
      .chatMessageMarkAsRead(message.chatRoomId, message.id)
      .subscribe({
        next: () => { },
        error: err => { },
      });
  }

  isUserAtBottom(): boolean {
    const el = this.myScrollContainer?.nativeElement;
    if (!el) return true;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - 30;
  }

  onUserScroll(): void {
    if (!this.isUserAtBottom()) {
      this.autoScroll = false;
    }
  }

  scrollToBottom(): void {
    try {
      const el = this.myScrollContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    } catch { }
  }
   async ensureRoomId(): Promise<void> {
    if (this.joinRoomId) return;
    const loadId = this.data?.userInfo?.loadData?.loadId ?? this.data?.loadId;
    if (!loadId) return;
    return new Promise((resolve) => {
        this.socketService.getmessages({
            type: ChatRoomType.GROUP,
            loadId,
            pageSize: 1,
        }).subscribe({
            next: async (res) => {
                const roomId = res?.room?.id || res?.data?.room?.id;
                if (roomId && !this.joinRoomId) {
                    this.joinRoomId = String(roomId);
                    await this.socketService.joinRoom(this.joinRoomId);
                }
                resolve();
            },
            error: () => resolve(),
        });
    });
}

  loadMessages(): void {
    if (this.isLoading || !this.hasMore) return;
    this.isLoading = true;
    const container = this.myScrollContainer?.nativeElement;
    const prevScrollHeight = container?.scrollHeight || 0;
    const isFirstLoad = this.cursorId === null;

    const cursorId =
      this.messages.length > 0
        ? String(this.messages[0].id)
        : "";
    const loadId = this.data?.userInfo?.loadData?.loadId
      ? this.data.userInfo.loadData.loadId
      : this.data?.loadId;

    const payload = {
      type: ChatRoomType.GROUP,
      loadId: loadId,
      pageSize: this.limit,
      cursorId,
    };

    this.socketService.getmessages(payload).subscribe({
      next: async (res) => {
      const messages = res?.messages || res?.data?.messages || [];
      this.chatMembers = res?.members || res?.data?.members || [];
      const pagination = res?.pagination || res?.data?.pagination;
      this.hasMore = pagination?.hasMore ?? false;
      this.cursorId = pagination?.nextCursorId ?? null;

      const roomId = res?.room?.id || res?.data?.room?.id;

      if (!this.joinRoomId && roomId) {
        this.joinRoomId = String(roomId);
        await this.socketService.joinRoom(this.joinRoomId);
      }
      if (!this.joinRoomId) {
          await this.ensureRoomId();
      }

      const uniqueMessages = messages.filter((msg: any) => {
        if (this.messageIdSet.has(msg.id)) return false;
        this.messageIdSet.add(msg.id);
        return true;
      });
      if (uniqueMessages.length) {
        const normalized = uniqueMessages
          .map(m => this.normalizeMessage(m))
          .reverse();
        this.messages = [...normalized, ...this.messages];
        const lastMessage = this.messages[this.messages.length - 1];
        this.markMessageAsRead(lastMessage);
        this.groupByDate();
      }

      this.isLoading = false;
      this.cdr.detectChanges();
      if (!isFirstLoad && container && uniqueMessages.length) {
        const newHeight = container.scrollHeight;
        container.scrollTop = newHeight - prevScrollHeight;
      }
      if (isFirstLoad) {
        setTimeout(() => this.scrollToBottom());
      }
      this.loadOnlineUsers(this.chatMembers)
      },
      error: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }
  // isOwnMessage(msg: any): boolean {
  //   return msg.senderId === this.profileId.id;
  // }

  onScrollUp(): void {
    if (this.isLoading || !this.hasMore) return;
    this.autoScroll = false;
    this.loadMessages();
  }

  normalizeMessage(msg: any) {
    let dateObj: Date;

    if (msg?.messageDate instanceof Date) {
      dateObj = msg.messageDate;
    } else if (msg?.messageDate) {
      const parsed = new Date(msg.messageDate);
      dateObj = isNaN(parsed.getTime()) ? new Date() : parsed;
    } else {
      dateObj = new Date();
    }

    let parsedMetadata: any = null;

    if (msg.metadata) {
      if (typeof msg.metadata === 'string') {
        try {
          parsedMetadata = JSON.parse(msg.metadata);
        } catch {
          parsedMetadata = null;
        }
      } else {
        parsedMetadata = msg.metadata;
      }
    }

    return {
      id: msg.id,
      senderProfileImage: msg.senderProfileImage,
      chatRoomId: msg.chatRoomId,
      senderId: msg.senderId,
      message: parsedMetadata?.system
  ? this.getSystemMessageText(parsedMetadata, msg.message)
  : msg.message,
      metadata: parsedMetadata,
      userName: msg?.sender?.name,
      messageType: msg.messageType,
       isSystem: parsedMetadata?.system === true,
      messageDate: dateObj,
      seenBy: msg.seenBy || [],
    };
  }
  // Add this helper method
  private getSystemMessageText(metadata: any, fallback: string): string {
    if (!metadata?.system) return fallback;
    if (metadata.action === 'member_removed') {
      return `${metadata.removedByName} removed ${metadata.removedUserName} from the group chat.`;
    }
    if (metadata.action === 'member_added') {
      return `${metadata.addedByName} added ${metadata.addedUserName} to the group chat.`;
    }
    return fallback;
  }
  isMessageSeen(chat: any): boolean {
    const totalMembers = 2;

    if (!chat?.seenBy) return false;

    return chat.seenBy.length === totalMembers;
  }

  isLastMessageOverall(chat: any): boolean {
    if (!this.messages.length) return false;

    const lastMessage = this.messages[this.messages.length - 1];
    return lastMessage.id === chat.id;
  }


  groupByDate(): void {
    const grouped: any = {};
    this.messages
  .filter(msg => msg.isSystem || (msg.message && msg.message.trim() !== ''))
  .forEach(msg => {
      const dateKey = msg.messageDate instanceof Date
        ? msg.messageDate.toDateString()
        : new Date(msg.messageDate).toDateString();
      grouped[dateKey] = grouped[dateKey] || [];
      grouped[dateKey].push(msg);
    });

    this.groupedMessages = Object.keys(grouped).map(date => ({
      date,
      messages: grouped[date],
    }));
  }

  trackByDate(index: number, item: any) {
    return item.date;
  }
  copyMessage(chat: any): void {
    if (!chat?.message || chat.metadata?.isDeleted) return;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(chat.message).then(
        () => {
          this.commonService.showSnakeBar('Message copied');
        },
        () => {
          this.fallbackCopy(chat.message);
        }
      );
    } else {
      this.fallbackCopy(chat.message);
    }
  }
  private fallbackCopy(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      this.commonService.showSnakeBar('Message copied');
    } catch {
      this.commonService.showSnakeBar('Failed to copy message');
    }

    document.body.removeChild(textarea);
  }


  sendMessage(text: string): void {
    if (!this.socketReady) return;
    if (this.hasAnyPendingUpload) return;
    const attachments = this.pendingAttachments.filter(a => a.status === 'done');
    const hasText = text && text.trim().length > 0;
    if (!hasText && !attachments.length) { this._emptyMessageError = true; return; }
    this._emptyMessageError = false;
    const loadData = this.data.userInfo.loadData;
    let senderId = Number(this.userId)

    const loadId = loadData?.loadId ?? this.data?.loadId;
    const metadata: any = {};
    if (this.replyToMessage) {
      metadata.replyTo = this.replyToMessage;
    }

    const sendPayload = (payload: any): void => {
      this.socketService.sendMessage(payload, async (ack) => {
        const msg = ack?.data;
        if (!msg) return;

        if (this.replyToMessage) {
          msg.metadata = {
            ...(msg.metadata || {}),
            replyTo: this.replyToMessage,
          };
        }

        const normalized = this.normalizeMessage(msg);
        if (!this.messageIdSet.has(normalized.id)) {
          this.messageIdSet.add(normalized.id);
          this.messages.push(normalized);
          this.groupByDate();
          this.scrollToBottom();
          this.newMessagesCount = 0;
          this.hasNewMessages = false;
        }
      });
    };

    if (hasText) {
      sendPayload({
        type: ChatRoomType.GROUP,
        senderId,
        loadId,
        message: text.trim(),
        metadata: Object.keys(metadata).length ? metadata : null,
        messageType: ChatMessageType.TEXT,
      });
    }

    attachments.forEach(att => {
      sendPayload({
        type: ChatRoomType.GROUP,
        senderId,
        loadId,
        message: att.name,
        metadata: {
          ...(this.replyToMessage ? { replyTo: this.replyToMessage } : {}),
          attachment: {
            name: att.name,
            key: att.key,
            url: att.url,
            type: att.type,
            size: att.size,
            isImage: att.isImage,
          },
        },
        messageType: att.isImage ? ChatMessageType.IMAGE : ChatMessageType.FILE,
      });
    });

    this.replyToMessage = null;

    this.resetFile();
  }

  startReplyMessage(chat: any): void {
    this.replyToMessage = {
      messageId: chat.id,
      message: chat.message,
      senderName: chat.userName,
    };
    // this.editedText = chat.message;
    this.editingMessageId = null;
  }
  canEditDeleteMessage(chat: any): boolean {
    if (!(chat?.messageDate instanceof Date)) return false;
    const diffMinutes =
      (Date.now() - chat.messageDate.getTime()) / (1000 * 60);
    return diffMinutes <= 20;
  }

  canEditMessage(chat: any): boolean {
    if (this.isImageMessage(chat) || this.isFileMessage(chat)) return false;
    if (chat?.metadata?.attachment) return false;
    return this.canEditDeleteMessage(chat);
  }



  cancelReplyMessage(): void {
    this.replyToMessage = null;
    // this.editedText = '';
  }

  startEditMessage(message: any): void {
    if (message.senderId !== this.currectUserId) return;
    // Images and documents are not editable.
    if (!this.canEditMessage(message)) return;
    this.editingMessageId = message.id;
    this.editedText = message.message;
  }

  cancelEdit(): void {
    this.editingMessageId = null;
    this.editedText = '';
  }

  saveEdit(message: any): void {
    if (!this.editedText.trim()) return;
    const payload = {
      messageId: message.id,
      userId: this.currectUserId,
      newMessage: this.editedText.trim(),
    };

    this.socketService.editMessage(payload, (ack) => {
      if (!ack?.data) return;
      const updated = this.normalizeMessage(ack.data);
      const index = this.messages.findIndex(m => m.id === updated.id);
      if (index !== -1) {
        this.messages[index] = {
          ...this.messages[index],
          message: updated.message,
          metadata: {
            ...(this.messages[index].metadata || {}),
            ...(updated.metadata || {}),
            edited: true
          }
        };
        this.groupByDate();
      }
      this.cancelEdit();
    });
  }

  shouldShowAvatar(messages: any[], index: number): boolean {
    if (index === 0) return true;
    const current = messages[index];
    const previous = messages[index - 1];
    if (current.senderId !== previous.senderId) return true;
    const diffMs =
      current.messageDate.getTime() - previous.messageDate.getTime();
    const diffMinutes = diffMs / (1000 * 60);
    return diffMinutes > 1;
  }
  shouldShowTime(messages: any[], index: number): boolean {
    const current = messages[index];
    const next = messages[index + 1];
    if (!next) return true;
    if (current.senderId !== next.senderId) return true;
    const diffMs =
      next.messageDate.getTime() - current.messageDate.getTime();
    const diffMinutes = diffMs / (1000 * 60);
    return diffMinutes > 1;
  }


  shouldShowUserName(messages: any[], index: number): boolean {
    return this.shouldShowAvatar(messages, index);
  }


  onFileSelected(event: any): void {
    const files: File[] = Array.from((event?.target?.files || []) as FileList);
    this.handleSelectedFiles(files);
    if (event?.target) {
      event.target.value = '';
    }
  }

  onAttachmentDragEnter(event: DragEvent): void {
    event.preventDefault();
    if (!this.isChatAccess) {
      return;
    }
    this.dragCounter++;
    this.isDraggingAttachment = true;
  }

  onAttachmentDragOver(event: DragEvent): void {
    event.preventDefault();
    if (!this.isChatAccess) {
      return;
    }
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    this.isDraggingAttachment = true;
  }

  onAttachmentDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter--;
    if (this.dragCounter <= 0) {
      this.dragCounter = 0;
      this.isDraggingAttachment = false;
    }
  }

  onAttachmentDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragCounter = 0;
    this.isDraggingAttachment = false;
    if (!this.isChatAccess) {
      return;
    }
    const files: File[] = Array.from((event?.dataTransfer?.files || []) as FileList);
    this.handleSelectedFiles(files);
  }

  private handleSelectedFiles(files: File[]): void {
    if (!files.length) {
      return;
    }
    files.forEach((file) => this.addPendingAttachment(file));
  }

  private getAttachmentIdentity(file: File): string {
    return `${(file?.name || '').trim().toLowerCase()}::${Number(file?.size || 0)}`;
  }

  private isVideoFile(file: File): boolean {
    if (!!file?.type && file.type.startsWith('video/')) {
      return true;
    }
    const fileName = (file?.name || '').toLowerCase();
    const extension = fileName.split('.').pop() || '';
    const knownVideoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'wmv', 'webm', 'flv', 'm4v', '3gp', 'mpeg', 'mpg'];
    return knownVideoExtensions.includes(extension);
  }

  private isDuplicateAttachment(file: File): boolean {
    const identity = this.getAttachmentIdentity(file);
    return this.pendingAttachments.some((attachment) => {
      if (!attachment?.name || !attachment?.size) {
        return false;
      }
      return `${attachment.name.trim().toLowerCase()}::${Number(attachment.size || 0)}` === identity;
    });
  }

  private addPendingAttachment(file: File): void {
    if (this.isDuplicateAttachment(file)) {
      this.commonService.showSnakeBar('This file has already been added.');
      return;
    }

    if (this.isVideoFile(file)) {
      this.commonService.showSnakeBar('This video format is not supported.');
      return;
    }

    const pending: PendingAttachment = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      isImage: !!file.type && file.type.startsWith('image/'),
      previewUrl: !!file.type && file.type.startsWith('image/') ? URL.createObjectURL(file) : '',
      key: '',
      url: '',
      status: 'uploading',
    };
    if (!this.isAllowedFileType(file)) {
      this.commonService.showSnakeBar('Unsupported file type. Allowed: images, PDF, DOC/DOCX, XLS/XLSX, PPT/PPTX, TXT, CSV.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      this.commonService.showSnakeBar('Max Size of Document should be 5MB.');
      return;
    }
    this.pendingAttachments.push(pending);
    this.uploadPendingAttachment(pending);
  }

  private isAllowedFileType(file: File): boolean {
    const allowedTypes = [
      'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/svg+xml',
      'application/pdf', 'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain', 'text/csv', 'application/zip', 'application/x-zip-compressed',
    ];
    if (allowedTypes.includes(file.type)) return true;
    const name = (file.name || '').toLowerCase();
    const ext = name.split('.').pop() || '';
    const allowedExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'zip'];
    return allowedExts.includes(ext);
  }

  uploadPendingAttachment(pending: PendingAttachment): void {
    pending.status = 'uploading';
    const fd = new FormData();
    fd.append('file', pending.file);
    this.http.post('master/upload-file', fd).subscribe(
      (res: any) => {
        pending.status = 'done';
        pending.key = res?.data?.key || '';
        pending.url = res?.data?.signedUrl || res?.data?.blobUrl || '';
      },
      () => {
        pending.status = 'error';
        pending.error = 'Upload failed. Please try again.';
      }
    );
  }

  removePendingAttachment(id: string): void {
    const idx = this.pendingAttachments.findIndex(a => a.id === id);
    if (idx === -1) return;
    const removed = this.pendingAttachments[idx];
    if (removed.previewUrl) URL.revokeObjectURL(removed.previewUrl);
    this.pendingAttachments.splice(idx, 1);
  }

  get hasAnyPendingUpload(): boolean {
    return this.pendingAttachments.some(a => a.status === 'uploading');
  }

  formatFileSize(bytes: number): string {
    if (!bytes) return '0 B';
    const units = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${units[i]}`;
  }

  downloadAttachment(chat: any): void {
    const att = chat?.metadata?.attachment;
    if (!att?.key) {
      this.commonService.showSnakeBar('Attachment not available');
      return;
    }
    this.http.get(
      this.getProxyAttachmentUrl(att.key, 'attachment'),
      this.getBlobRequestOptions()
    ).subscribe({
      next: (blob: Blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        this.triggerDownload(objectUrl, att.name || 'download');
        setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
      },
      error: () => {
        this.commonService.showSnakeBar('Unable to download file');
      }
    });
  }

  private triggerDownload(url: string, fileName: string): void {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.target = '_blank';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  onImageError(event: any, chat: any): void {
    const img = event.target as HTMLImageElement;
    if (!img) return;
    const att = chat?.metadata?.attachment;
    if (!att?.key) {
      img.style.display = 'none';
      return;
    }
    const cached = this.attachmentPreviewCache.get(att.key);
    if (cached) {
      img.src = cached;
      return;
    }
    this.ensureAttachmentPreview(att.key);
    if (img.dataset?.retried) {
      img.style.display = 'none';
      return;
    }
    img.dataset.retried = 'true';
    img.style.display = '';
  }

  getAttachmentImageSrc(chat: any): string {
    const att = chat?.metadata?.attachment;
    if (!att) {
      return '';
    }
    if (att?.key) {
      const cached = this.attachmentPreviewCache.get(att.key);
      if (cached) {
        return cached;
      }
      this.ensureAttachmentPreview(att.key);
    }
    return att?.url || '';
  }

  private getProxyAttachmentUrl(key: string, disposition: 'inline' | 'attachment'): string {
    return `master/document?key=${encodeURIComponent(key)}&disposition=${disposition}`;
  }

  private ensureAttachmentPreview(key: string): void {
    if (!key || this.attachmentPreviewCache.has(key) || this.attachmentPreviewLoading.has(key)) {
      return;
    }
    // getAttachmentImageSrc() is bound in the template and runs on every change
    // detection pass. Without a negative cache, a single storage outage (e.g. a
    // transient DNS failure) re-issues the request on every cycle, producing a
    // storm of 500s. Back off instead.
    const failedAt = this.attachmentPreviewFailed.get(key);
    if (failedAt !== undefined) {
      if (Date.now() - failedAt < this.attachmentPreviewRetryMs) {
        return;
      }
      this.attachmentPreviewFailed.delete(key);
    }
    this.attachmentPreviewLoading.add(key);
    this.http.get(
      this.getProxyAttachmentUrl(key, 'inline'),
      this.getBlobRequestOptions()
    ).subscribe({
      next: (blob: Blob) => {
        this.attachmentPreviewLoading.delete(key);
        if (!blob || !blob.size) {
          this.attachmentPreviewFailed.set(key, Date.now());
          this.cdr.detectChanges();
          return;
        }
        const objectUrl = URL.createObjectURL(blob);
        this.attachmentPreviewCache.set(key, objectUrl);
        this.attachmentPreviewFailed.delete(key);
        this.cdr.detectChanges();
      },
      error: () => {
        this.attachmentPreviewLoading.delete(key);
        this.attachmentPreviewFailed.set(key, Date.now());
      }
    });
  }

  private getBlobRequestOptions() {
    const token = localStorage.getItem('userToken');
    const headersConfig: any = {};
    if (token) {
      headersConfig.Authorization = 'Bearer ' + token;
      headersConfig.Device = 'Desktop';
    }
    return {
      headers: new HttpHeaders(headersConfig),
      responseType: 'blob' as const
    };
  }

  isImageMessage(chat: any): boolean {
    return !chat?.metadata?.isDeleted
      && chat?.messageType === ChatMessageType.IMAGE
      && !!chat?.metadata?.attachment;
  }

  isFileMessage(chat: any): boolean {
    return !chat?.metadata?.isDeleted
      && chat?.messageType === ChatMessageType.FILE
      && !!chat?.metadata?.attachment;
  }

  isTextMessage(chat: any): boolean {
    return !this.isImageMessage(chat) && !this.isFileMessage(chat);
  }

  resetFile(): void {
    this.isDraggingAttachment = false;
    this.pendingAttachments.forEach(a => {
      if (a.previewUrl) URL.revokeObjectURL(a.previewUrl);
    });
    this.pendingAttachments = [];
    if (this.myInputVariable?.nativeElement) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

  closeChatBox(): void {
    this.openChatBox = false
    this.attachmentPreviewCache.forEach((url) => {
      try { URL.revokeObjectURL(url); } catch {}
    });
    this.attachmentPreviewCache.clear();
    this.attachmentPreviewLoading.clear();
    this.attachmentPreviewFailed.clear();
    this.dialogRef.close('save');
  }

  toggleSeenPopover(chat: any, event: MouseEvent) {
    event.stopPropagation();

    if (this.seenPopoverMessage === chat) {
      this.seenPopoverMessage = null;
    } else {
      this.seenPopoverMessage = chat;
    }
  }
  deleteMessage(chat: any): void {
    if (!chat?.id) {
      this.commonService.showSnakeBar('Some error occurred');
      return;
    }

    this._sharedModalService
      .delete('Do you really want to delete this message?')
      .subscribe((res: boolean) => {
        if (!res) return;
        this.socketService.deleteMessage(chat.id, this.currectUserId);
        this.commonService.showSnakeBar('Message deleted');
      });
  }
  onContainerScroll(): void {
    const el = this.myScrollContainer?.nativeElement;
    if (!el) return;

    const atTop = el.scrollTop < 50;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 50;
    if (atBottom) {
      this.autoScroll = true;
      if (this.hasNewMessages) {
        this.newMessagesCount = 0;
        this.hasNewMessages = false;
      }
    } else {
      this.autoScroll = false;
    }

    if (!this.isSearchJump) {
      if (atTop && !this.isLoading && this.hasMore) {
        this.loadMessages();
      }
      return;
    }
    if (atTop && !this.isLoading && this.hasMoreOlder) {
      this.loadOlderFromSearch();
    }

    if (atBottom && !this.isLoading && this.hasMoreNewer) {
      this.loadNewerFromSearch();
    }
  }



  // add these methods after loadOnlineUsers

  filterMembers() {
    const q = this.memberSearchQuery.toLowerCase();
    this.filteredMembers = this.chatMemberName.filter((m: any) =>
      m.name.toLowerCase().includes(q)
    );
  }

  clearMemberSearch() {
    this.memberSearchQuery = '';
    this.filteredMembers = [...this.chatMemberName];
  }

searchUsersToAdd(): void {
    if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
    }

    if (!this.addMemberQuery?.trim()) {
      this.userSearchResults = [];
        this.isSearchingUsers = false;
      return;
    }
    this.isSearchingUsers = true;

    this.searchDebounceTimer = setTimeout(async () => {
        if (!this.joinRoomId) {
            await this.ensureRoomId();
        }
        const loadId = this.data?.userInfo?.loadData?.loadId ?? this.data?.loadId;

        if (!this.joinRoomId && !loadId) {
            this.isSearchingUsers = false;
            this.commonService.showSnakeBar('Chat room not loaded yet');
            return;
        }
        const roomId = this.joinRoomId
            ? Number(this.joinRoomId)
            : 0;

        if (!roomId) {
            this.isSearchingUsers = false;
            this.commonService.showSnakeBar('Chat room not loaded yet');
            return;
        }

        this.socketService
            .searchChatMembers(roomId, this.addMemberQuery.trim())
            .subscribe({
                next: (res) => {
                    this.userSearchResults = res?.data || [];
                    this.isSearchingUsers = false;
                    this.cdr.detectChanges();
                },
                error: () => {
                    this.isSearchingUsers = false;
                    this.commonService.showSnakeBar('Failed to search members');
                },
            });
    }, 400);
}


  clearAddSearch() {
    this.addMemberQuery = '';
    this.userSearchResults = [];
  }
  canUserHaveChatAccess() {
       const loadId = this.data?.userInfo?.loadData?.loadId
      ? this.data.userInfo.loadData.loadId
      : this.data?.loadId;
  this.commonService.canUserHaveChatAccess(Number(loadId)).subscribe(
    (res) => {
      if (res.statusCode === 200 || res.statusCode === 201) {
        this.isChatAccess = res.data?.canAccess;
      } else {
        this.isChatAccess = false;
        this.commonService.showSnakeBar(res.message);
      }
    },
    (error) => {
      this.isChatAccess = false;
      this.commonService.showSnakeBar(
        error?.error?.message || error?.message || 'Something went wrong'
      );
    }
  );
}

addMember(user: any): void {
  if (!this.joinRoomId) return;
  if (user.isAlreadyInRoom) {
    this.commonService.showSnakeBar('User is already in this chat');
    return;
  }

  this.isAddingMember = user.id;

  this.socketService
    .addChatMember({
      roomId: Number(this.joinRoomId),
      targetUserId: user.id,
    })
    .subscribe({
      next: (res) => {
        this.isAddingMember = null;

        if (res?.statusCode && res.statusCode !== 200) {
          this.commonService.showSnakeBar(res.message || 'Failed to add member');
          return;
        }
        this.userSearchResults = this.userSearchResults.map(u =>
          u.id === user.id ? { ...u, isAlreadyInRoom: true } : u
        );

        const alreadyInList = this.chatMemberName?.some((m: any) => m.id === user.id);
        if (!alreadyInList) {
          const newMember = {
            id: user.id,
            name: user.name,
            role: user.role,
            userType: user.userType ?? null,
            companyName: user.companyName ?? null,
            logo: user.logo ?? null,
            isDefault: user.isDefault ?? false,
            isLoadPoster: user.isLoadPoster ?? false,
            isCarrierAdmin: user.isCarrierAdmin ?? false,
            isOnline: false,
          };
          this.chatMembers = [...(this.chatMembers || []), newMember];
          this.chatMemberName = [...(this.chatMemberName || []), newMember];
          this.filteredMembers = [...this.chatMemberName];
        }

        this.commonService.showSnakeBar(`${user.name} added to chat`);
        this.cdr.detectChanges();
      },
      error: (err) => {
       this.isAddingMember = null;
        this.commonService.showSnakeBar(
          err?.error?.message || 'Failed to add member'
        );
      },
    });
}

removeMember(member: any): void {
  if (!this.joinRoomId) return;

  if (member.id === this.currectUserId) {
    this.commonService.showSnakeBar('You cannot remove yourself from the chat');
    return;
  }

  this.isRemovingMember = member.id;

  this.socketService
    .removeChatMember({
      roomId: Number(this.joinRoomId),
      targetUserId: member.id,
    })
    .subscribe({
      next: (res) => {
        this.isRemovingMember = null;

        if (res?.statusCode && res.statusCode !== 200) {
          this.commonService.showSnakeBar(res.message || 'Failed to remove member');
          return;
        }
        this.chatMembers = this.chatMembers?.filter((m: any) => m.id !== member.id) || [];
        this.chatMemberName = this.chatMemberName?.filter((m: any) => m.id !== member.id) || [];
        this.filteredMembers = [...this.chatMemberName];

        this.userSearchResults = this.userSearchResults.map(u =>
          u.id === member.id ? { ...u, isAlreadyInRoom: false } : u
        );

        this.commonService.showSnakeBar(`${member.name} removed from chat`);
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isRemovingMember = null;
        this.commonService.showSnakeBar(
          err?.error?.message || 'Failed to remove member'
        );
      },
    });
}

  getInitials(name: string): string {
    if (!name) return '';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  }
   canRemoveMember(member: any): boolean {
      return !member.isDefault;
    }


}